// extracted by mini-css-extract-plugin
export default {"Card":"DashboardCard_Card__nnizb","CardLabel":"DashboardCard_CardLabel__U9KRX","CardValue":"DashboardCard_CardValue__BjKu5"};